import { createAsyncThunk } from '@reduxjs/toolkit';

import { handleListFetch } from '../apiHelpers';

import {
    APIClaimRoleMembershipDelete,
    APIClaimRoleMembershipGetList,
    APIClaimRoleMembershipPost,
    APIClaimRoleMembershipPostParams,
    APIClaimRoleMembershipPostResponse,
    APIClaimRoleMembershipPut,
    APIClaimRoleMembershipPutParams,
    APIClaimRoleMembershipPutResponse
} from './ClaimRoleMembership.api';

export type ClaimRoleMembershipExtended = {
    id: string;
    name: string;
    claimDataTypeName: string;
}

const mapDataToRows = (data: Record<string, string>[]) : ClaimRoleMembershipExtended[] => data.map(item => ({
    ...item,
    id: `${item.claimId}.${item.roleId}`,
    name: item.roleName,
    claimDataTypeName: item.claimDataTypeName
}));

export const fetchClaimRoleMembershipList = createAsyncThunk('claim-role/fetchClaimRoleMemberships', async (item: { tenantId: string, claimId: string, signal?: AbortSignal }) => {
    const response = await APIClaimRoleMembershipGetList(item);
    return mapDataToRows(response.data);
});

export type PostClaimRoleMembershipThunkResponse = {
    item: APIClaimRoleMembershipPostParams,
    response: APIClaimRoleMembershipPostResponse,
    rows: ClaimRoleMembershipExtended[]
}

export const postClaimRoleMembership = createAsyncThunk(
    'role-claim/postRoleClaimMembership',
    async (item: APIClaimRoleMembershipPostParams) => {
        const response = await APIClaimRoleMembershipPost(item);
        const rows = await handleListFetch(APIClaimRoleMembershipGetList({ tenantId: item.tenantId, claimId: item.claimId }));
        return {
            item,
            response,
            rows: mapDataToRows(rows)
        };
    }
);

export type PutClaimRoleMembershipThunkResponse = {
    item: APIClaimRoleMembershipPutParams,
    response: APIClaimRoleMembershipPutResponse,
    rows: ClaimRoleMembershipExtended[]
}

export const putClaimRoleMembership = createAsyncThunk(
    'role-claim/putRoleClaimMembership',
    async (item: APIClaimRoleMembershipPutParams) => {
        const response = await APIClaimRoleMembershipPut(item);
        const rows = await handleListFetch(APIClaimRoleMembershipGetList({ tenantId: item.tenantId, claimId: item.claimId }));
        return {
            item,
            response,
            rows: mapDataToRows(rows)
        };
    }
);

export const deleteClaimRoleMembership = createAsyncThunk('claim-role/deleteClaimRoleMemberships', async (item: { tenantId: string, roleId: string, claimId: string}) => {
    const response = await APIClaimRoleMembershipDelete(item);
    const data = await handleListFetch(APIClaimRoleMembershipGetList({ tenantId: item.tenantId, claimId: item.claimId }));
    return {
        response,
        rows: mapDataToRows(data)
    };
});
